import { render, staticRenderFns } from "./IconBadge.vue?vue&type=template&id=5eeb30b9&scoped=true&"
import script from "./IconBadge.vue?vue&type=script&lang=js&"
export * from "./IconBadge.vue?vue&type=script&lang=js&"
import style0 from "./IconBadge.vue?vue&type=style&index=0&id=5eeb30b9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eeb30b9",
  null
  
)

export default component.exports